import { Toast } from 'onze-ds-minuto'
import { useBaseContext } from 'contexts/BaseContext'

const Notification = () => {
  const { toastProps, toggleToast, actions: { closeNotification } } = useBaseContext()

  return (
    <Toast
      variant='error'
      hasIcon={true}
      isOpen={toggleToast}
      onClose={closeNotification}
      {...toastProps}
    />
  )
}

export default Notification